module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#environment",
      toString: function () {
        return this.url;
      }
    }